import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-[60vh] flex items-center justify-center px-4 py-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("section", { class: "w-full max-w-[640px] rounded-[2.4rem] border border-black/10 bg-white p-8 shadow-sm text-center space-y-4" }, [
      _createElementVNode("p", { class: "m-0 text-[1.8rem] font-semibold text-black" }, "¡Genial! Has reservado tu cita"),
      _createElementVNode("p", { class: "m-0 text-[1.4rem] text-[color:var(--gray)]" }, " Recibirás un email de confirmación ahora y un recordatorio antes de la cita. ")
    ], -1)
  ]))]))
}